import Typography from "@mui/material/Typography";
import { FilterChip, FilterChipRef } from "../FilterChip";

import React, { useMemo } from "react";

import { EntityTypeFilterValue } from "../../../legacy/types/companyFilter";
import { getCompanyTypeLabel } from "./components/utils";
import { CompanyTypeFilterOptions } from "./components/CompanyTypeFilterOptions";

interface CompanyTypeFilterChipProps {
  value: EntityTypeFilterValue;
  onChange: (value: EntityTypeFilterValue) => void;
}

export const CompanyTypeFilterChip: React.FC<CompanyTypeFilterChipProps> = ({
  value,
  onChange,
}: CompanyTypeFilterChipProps) => {
  const filterChipRef = React.useRef<FilterChipRef>(null);

  const handleCompanyTypeChange = React.useCallback(
    (newValue: EntityTypeFilterValue) => {
      onChange(newValue);
      filterChipRef.current?.closePopover();
    },
    [onChange]
  );

  const label = useMemo(() => {
    return value
      ? `Company Type: ${getCompanyTypeLabel(value)}`
      : "Company Type: All";
  }, [value]);

  return (
    <FilterChip
      ref={filterChipRef}
      label="Company Type"
      dataTestId="company-type-filter-chip"
      getSelectedCount={() => 1}
      popoverOptions={{ title: "", disableActionButtons: true }}
      renderLabel={(_label: string, _count: number) => {
        return (
          <Typography component="span" color="text.primary">
            {label}
          </Typography>
        );
      }}
    >
      <CompanyTypeFilterOptions
        value={value}
        onChange={handleCompanyTypeChange}
        noClearButton
        noTitle
      />
    </FilterChip>
  );
};
